import http from "../common/http";
import authHeader from "./header";
import { SERVICE_API_URL } from "../common/config";

const userFindAll = (params) => {
  return http.get(SERVICE_API_URL + `/users`, {
    params: params,
    headers: authHeader(),
  });
};

const regUser = (params) => {
  return http.post(SERVICE_API_URL + `/users`, params, {
    headers: authHeader(),
  });
};

const modifyUser = (id, params) => {
  return http.post(SERVICE_API_URL + `/users/put/${id}`, params, {
    headers: authHeader(),
  });
};

const deleteUser = (id) => {
  return http.post(SERVICE_API_URL + `/users/delete/${id}`, {}, {
    headers: authHeader(),
  });
};

export default {
  userFindAll,
  regUser,
  modifyUser,
  deleteUser,
};
